import ModalFormWrapper from "components/ModalForm/ModalFormWrapper";
import { UseFieldArrayAppend, UseFieldArrayUpdate } from "react-hook-form";
import PlusCirlceButton from "components/Button/PlusCircleButton";
import { PropsWithChildren } from "react";
import TemplateReminderForm from "../Form/TemplateReminderForm";

interface AddTemplateReminderButtonProps extends PropsWithChildren {
  value: any;
  append: UseFieldArrayAppend<any>;
  update: UseFieldArrayUpdate<any>;
  index: number;
  isNew?: boolean;
  eid?: string;
}

export default function AddTemplateReminderButton({
  children, eid, value, index, append, update, isNew = false,
}: AddTemplateReminderButtonProps) {
  return (
    <ModalFormWrapper
      modalHeader={isNew ? "Add Reminder" : `Update Reminder ${index + 1}`}
      size="3xl"
      button={children ?? <PlusCirlceButton aria-label="Add Reminder" label="Add Reminder" />}
      eid={eid}
    >
      <TemplateReminderForm value={value} index={index} append={append} update={update} isNew={isNew} />
    </ModalFormWrapper>
  );
}
